module.exports = __webpack_public_path__ + "d664201f/img/print-icon.d8dbbca5.svg";